import { useContext } from 'react';

import { ConfigContext } from './context';

/** Returns the global app config */
export const useConfig = () => useContext(ConfigContext);
